export default __webpack_public_path__ + "static/media/Error404.3b7cdc39.png";